import { Children, useMemo } from 'react';
export function useChildrenValidation(children, componentName, AllowedChildren) {
  useMemo(function () {
    Children.forEach(children, function (child) {
      var includesType = Array.isArray(AllowedChildren) ? AllowedChildren.includes(child.type) || AllowedChildren.includes(child.type.target) : child.type === AllowedChildren || child.type.target === AllowedChildren;

      if (!includesType) {
        throw new Error(componentName + " only allows " + (Array.isArray(AllowedChildren) ? AllowedChildren.map(function (item) {
          return item.displayName;
        }).join(', ') : AllowedChildren.displayName) + " as immediate children. Found invalid child " + child.type.displayName + ".");
      }
    });
  }, [children, componentName, AllowedChildren]);
}